import type { StateCreator } from 'zustand';
import type { ParticipationEntry } from '@abs/shared-types';
import { generateId } from '@/utils/id';

export interface ParticipationSlice {
  participationEntries: ParticipationEntry[];

  addParticipation: (entry: Omit<ParticipationEntry, 'id' | 'createdAt' | 'updatedAt'>) => string;
  updateParticipation: (id: string, updates: Partial<Omit<ParticipationEntry, 'id' | 'createdAt'>>) => void;
  deleteParticipation: (id: string) => void;
  deleteParticipationByCourse: (courseId: string) => void;
}

export const createParticipationSlice: StateCreator<ParticipationSlice> = (set) => ({
  participationEntries: [],

  addParticipation: (entryData) => {
    const id = generateId();
    const now = new Date().toISOString();
    const entry: ParticipationEntry = {
      ...entryData,
      id,
      createdAt: now,
      updatedAt: now,
    };
    set((state) => ({
      participationEntries: [...state.participationEntries, entry],
    }));
    return id;
  },

  updateParticipation: (id, updates) => {
    set((state) => ({
      participationEntries: state.participationEntries.map((e) =>
        e.id === id
          ? { ...e, ...updates, updatedAt: new Date().toISOString() }
          : e,
      ),
    }));
  },

  deleteParticipation: (id) => {
    set((state) => ({
      participationEntries: state.participationEntries.filter((e) => e.id !== id),
    }));
  },

  deleteParticipationByCourse: (courseId) => {
    set((state) => ({
      participationEntries: state.participationEntries.filter((e) => e.courseId !== courseId),
    }));
  },
});
